import { lazy } from 'react'

import IconFont from '@/components/IconFont'
import LazyLoadable from '@/components/LazyLoadable'
import UserList from '@/pages/platform/user/userList'

const OrderList = LazyLoadable(lazy(() => import('@/pages/platform/order/orderList')))
const ConsultList = LazyLoadable(lazy(() => import('@/pages/platform/consult/list')))
const SourceRecords = LazyLoadable(lazy(() => import('@/pages/platform/consult/sourceRecords')))
const CouponList = LazyLoadable(lazy(() => import('@/pages/platform/coupon/list')))
const CouponCreate = LazyLoadable(lazy(() => import('@/pages/platform/coupon/create')))
// const InvoiceList = LazyLoadable(lazy(() => import('@/pages/platform/invoice/list')))
const WithdrawList = LazyLoadable(lazy(() => import('@/pages/platform/promotion/withdraw/list')))
const PromotionPersonalList = LazyLoadable(lazy(() => import('@/pages/platform/promotion/personnel/list')))
// const OrganizationList = LazyLoadable(lazy(() => import('@/pages/platform/organization/list')))
// const UserList = LazyLoadable(lazy(() => import('@/pages/platform/user/list')))
const PermissionList = LazyLoadable(lazy(() => import('@/pages/platform/permission')))
const AccessTokenPage = LazyLoadable(lazy(() => import('@/pages/platform/accessToken')))
// const BusinessList = LazyLoadable(lazy(() => import('@/pages/platform/business/list')))
const Dashboard = LazyLoadable(lazy(() => import('@/pages/platform/dashboard')))
const Apps = LazyLoadable(lazy(() => import('@/pages/platform/apps')))
const MarketingSourcePage = LazyLoadable(lazy(() => import('@/pages/platform/marketingSource')))
const MQLFollowupList = LazyLoadable(lazy(() => import('@/pages/platform/mqlFollowup')))

const platformRouters = [
  {
    name: '数据看板',
    path: '/platform/dashboard',
    icon: <IconFont type='icon-shujukanban' />,
    element: <Dashboard />,
  },
  {
    name: '订单管理',
    path: '/platform/order',
    icon: <IconFont type='icon--dingdanguanli' />,
    children: [
      {
        path: 'list',
        name: '订单列表',
        element: <OrderList />,
      },
      {
        path: 'mql-followups',
        name: '跟进名单',
        element: <MQLFollowupList />,
      },
    ],
  },
  {
    name: '商机管理',
    path: '/platform/consult',
    icon: <IconFont type='icon-shangjibaojia' />,
    children: [
      {
        path: 'list',
        name: '商机列表',
        element: <ConsultList />,
      },
      {
        path: 'source-records',
        name: '来源记录',
        element: <SourceRecords />,
      },
    ],
  },
  {
    name: '用户管理',
    path: '/platform/user',
    icon: <IconFont type='icon-yonghu' />,
    children: [
      {
        path: 'list',
        name: '用户列表',
        element: <UserList />,
      },
    ],
  },
  {
	name: '来源管理',
	path: '/platform/marketing-source',
	icon: <IconFont type='icon-yonghu' />,
	element: <MarketingSourcePage />,
  },
  {
    name: '应用管理',
    path: '/platform/apps',
    icon: <IconFont type='icon-AppStore' />,
    element: <Apps />,
  },
  {
    name: '优惠券管理',
    path: '/platform/coupon',
    icon: <IconFont type='icon-youhuiquan' />,
    children: [
      {
        path: 'list',
        name: '优惠券列表',
        element: <CouponList />,
      },
      {
        path: 'create',
        name: '生成优惠券',
        element: <CouponCreate />,
      },
    ],
  },
  // {
  //   name: '发票管理',
  //   path: '/platform/invoice',
  //   icon: <IconFont type='icon-fapiao' />,
  //   children: [
  //     {
  //       path: 'list',
  //       name: '发票列表',
  //       element: <InvoiceList />,
  //     },
  //   ],
  // },
  {
    name: '推广大使',
    path: '/platform/promotion',
    icon: <IconFont type='icon-dianputuiguang' />,
    children: [
      {
        path: 'personal',
        name: '推广大使列表',
        element: <PromotionPersonalList />,
      },
      {
        path: 'withdraw',
        name: '提现列表',
        element: <WithdrawList />,
      },
    ],
  },
  // {
  //   name: '空间管理',
  //   path: '/platform/organization',
  //   icon: <IconFont type='icon-isometricfenggetubiaosheji-' />,
  //   children: [
  //     {
  //       path: 'list',
  //       name: '空间列表',
  //       element: <OrganizationList />,
  //     },
  //   ],
  // },
  {
    name: '权限控制',
    path: '/platform/permission',
    icon: <IconFont type='icon-yonghuguanli' />,
    element: <PermissionList />,
  },
  {
    name: '密钥管理',
    path: '/platform/access-tokens',
    icon: <IconFont type='icon-chanpinguanli' />,
    element: <AccessTokenPage />,
  },
]

export default platformRouters
